import { useEffect } from "react";
import { useLayoutMode } from "../../hooks/useLayoutMode";
import { useViewportKeyboardInsets } from "../../hooks/useViewportKeyboardInsets";

/**
 * Product ViewportShellSync, without react-router: the console is one shell.
 */
export function ViewportShellSync() {
  const layoutMode = useLayoutMode();
  const insets = useViewportKeyboardInsets(true);

  useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }
    document.documentElement.setAttribute("data-layout-mode", layoutMode);
    document.body.setAttribute("data-shell-scroll", "lock");
    const root = document.documentElement.style;
    root.setProperty("--cordexa-keyboard-inset", `${insets.keyboardInsetBottom}px`);
    root.setProperty("--cordexa-safe-top-dynamic", `${insets.safeAreaTop}px`);
    root.setProperty("--cordexa-safe-bottom", `${insets.safeAreaBottom}px`);
    root.setProperty("--cordexa-layout-viewport-h", `${insets.layoutViewportHeight}px`);
  }, [layoutMode, insets]);

  return null;
}
